import { AnalyticsError, AnalyticsService } from '@rogers/analytics';
import { get, merge } from 'lodash';
import { Injectable } from '@angular/core';
import { CustomHttpErrorResponse } from '@rogers/self-serve-common';
import { LogService } from '@rci/log-service';

interface ErrorHandler {
  getAdditionalErrorPayload: Function;
  regex?: RegExp;
  url?: string;
  useRegex: boolean;
}

@Injectable({ providedIn: 'root' })
export class GlobalApiErrorTrackingService {
  private errorHandlers: Array<ErrorHandler> = [];

  constructor(
    private readonly analyticsService: AnalyticsService,
    private readonly logger: LogService,
  ) {}

  addErrorHandler(errorHandlers) {
    if (errorHandlers) {
      this.errorHandlers = this.errorHandlers.concat(errorHandlers);
    }
  }

  trackError(error: CustomHttpErrorResponse) {
    try {
      this.analyticsService.trackErrors(this.getErrorPayload(error));
    } catch (e) {
      this.logger.warn('error tracking api failure', e);
    }
  }

  private getErrorPayload(error: CustomHttpErrorResponse) {
    const code = error.error.status.code;
    let errorObject: AnalyticsError = {
      API: error.url,
      category: 'self serve',
      code,
      field: '',
      message: error.error.status.codeName,
      type: get(errorCodeAndTypes, code, 'http'),
    };
    const additionalErrorPayload = this.getAdditionalErrorPayload(error);
    if (additionalErrorPayload) {
      errorObject = merge(errorObject, additionalErrorPayload);
    }
    return [errorObject];
  }

  private getAdditionalErrorPayload(error: CustomHttpErrorResponse) {
    const errorHandler = this.errorHandlers.find(
      handler => (handler.useRegex && handler.regex.test(error.url)) || handler.url === error.url,
    );

    if (!errorHandler) {
      return null;
    }
    return errorHandler.getAdditionalErrorPayload(error);
  }
}

const errorCodeAndTypes = {
  '400.301': 'user',
  '403.301': 'user',
  '403.302': 'user',
  '403.303': 'user',
  '403.304': 'user',
  '403.305': 'user',
  '0': 'user',
};
